import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23341c70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-4 mb-16" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-primary-dark text-left lg:text-center px-4 mt-2 mb-6 font-extrabold lg:font-bold font-sarabun text-32px lg-text-56px" }, " Past Achievements ", -1))
const _hoisted_3 = { class: "container ml-0 lg:ml-48" }
const _hoisted_4 = { class: "step completed pt-8" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "v-stepper hidden lg:block" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "circle" }),
  /*#__PURE__*/_createElementVNode("div", { class: "line" })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header ml-2 lg:ml-14" }, "2020", -1))
const _hoisted_7 = { class: "content ml-2 lg:ml-14 text-xs" }
const _hoisted_8 = { class: "list" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 50,000 m2 Forest Area Planted (2020 only) ", -1))
const _hoisted_10 = { class: "list" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "100,000 m2 Forest Area Planted (Accumulated)", -1))
const _hoisted_12 = { class: "list" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 5,000 kg CO2 Sequestered (2020 only) ", -1))
const _hoisted_14 = { class: "list" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 10,000 kg CO2 Sequestered (Accumulated) ", -1))
const _hoisted_16 = { class: "list" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode()
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 500 Wildlife supported (2020 only) ", -1))
const _hoisted_19 = { class: "list" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 1,000 Wildlife supported (Accumulated) ", -1))
const _hoisted_21 = { class: "step completed" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "v-stepper hidden lg:block" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "circle" }),
  /*#__PURE__*/_createElementVNode("div", { class: "line" })
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header ml-2 lg:ml-14" }, "2021", -1))
const _hoisted_24 = { class: "content ml-2 lg:ml-14 text-xs" }
const _hoisted_25 = { class: "list flex flex-wrap" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 50,000 m2 Forest Area Planted (2021 only) ", -1))
const _hoisted_27 = { class: "list" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 50,000 m2 Forest Area Planted (Accumulated) ", -1))
const _hoisted_29 = { class: "list" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 5,000 kg CO2 Sequestered (2021 only) ", -1))
const _hoisted_31 = { class: "list" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 5,000 kg CO2 Sequestered (Accumulated) ", -1))
const _hoisted_33 = { class: "list" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode()
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 500 Wildlife supported (2021 only) ", -1))
const _hoisted_36 = { class: "list" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 500 Wildlife supported (Accumulated) ", -1))

import IconCorrect from '@/components/Icons/IconCorrect.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", null, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(IconCorrect),
              _hoisted_9
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(IconCorrect),
              _hoisted_11
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(IconCorrect),
              _hoisted_13
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(IconCorrect),
              _hoisted_15
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(IconCorrect),
              _hoisted_17,
              _hoisted_18
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(IconCorrect),
              _hoisted_20
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _createElementVNode("div", null, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createVNode(IconCorrect),
              _hoisted_26
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(IconCorrect),
              _hoisted_28
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createVNode(IconCorrect),
              _hoisted_30
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createVNode(IconCorrect),
              _hoisted_32
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createVNode(IconCorrect),
              _hoisted_34,
              _hoisted_35
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createVNode(IconCorrect),
              _hoisted_37
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})